export default __webpack_public_path__ + "static/media/Background_00141.a442d11a.png";